export enum VaryHeaders {
  EXPERIMENTS = 'X-Experiments',
  CUSTOMER_STATE = 'X-Customer-State',
  CUSTOMER_LIST = 'X-Customer-List',
  CUSTOMER_ID = 'X-Customer-ID',
}
